import { render, staticRenderFns } from "./LabResults.vue?vue&type=template&id=74d9c36b&scoped=true&"
import script from "./LabResults.vue?vue&type=script&lang=js&"
export * from "./LabResults.vue?vue&type=script&lang=js&"
import style0 from "./LabResults.vue?vue&type=style&index=0&id=74d9c36b&scoped=true&lang=css&"
import style1 from "./LabResults.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d9c36b",
  null
  
)

export default component.exports